import { defineMessages } from 'react-intl';

const messages = defineMessages({
  add: {
    id: 'components.Autocomplete.AddNewModal.add',
    defaultMessage: 'Add',
  },
  cancel: {
    id: 'components.Autocomplete.AddNewModal.cancel',
    defaultMessage: 'Cancel',
  },
});

export default messages;
